<template>
    <div class="container">
        <div class="personal_account">
            <h1 class="personal_account_title">
                Добрый день, <span v-html="user.name"></span>
            </h1>
            <div class="personal_account_company">
                <div class="personal_account_company_info">
                    <p>
                        Компания: <span v-html="selectedCompany?.name"></span>
                    </p>
                    <p>{{ selectedCompany?.name }} {{ selectedCompany?.inn }} </p>
                </div>
                <div class="personal_account_company_select">
                    <a-select v-model:value="selectedCompanyId" class="personal_account_company_select_item"
                        @change="changeCompany" :getPopupContainer="triggerNode => triggerNode.parentNode"
                        :virtual="false">
                        <a-select-option v-for="item in companies" :key="item.id" :value="item.id">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                </div>
            </div>
            <div class="card-container">
                <a-tabs v-model:activeKey="activeKey" type="card">
                    <template #renderTabBar="{ DefaultTabBar, ...props }">
                        <component :is="DefaultTabBar" v-bind="props" />

                        <div v-if="activeKey === 'appeals'" class="subtabs">
                            <button class="subtab_btn" :class="{ subtab_btn_active: appealsScope === 'my' }"
                                @click="() => changeSubtab('my')">
                                Мои заявки <span v-if="appealsTotals.my > 0">({{ appealsTotals.my }})</span>
                            </button>
                            <button class="subtab_btn" :class="{ subtab_btn_active: appealsScope === 'others' }"
                                @click="() => changeSubtab('others')">
                                Все обращения <span v-if="appealsTotals.others > 0">({{ appealsTotals.others }})</span>
                            </button>
                        </div>

                    </template>

                    <a-tab-pane key="contracts" tab="Мои договора">
                        <ContractsTab ref="contractsTab" :selectedCompanyId="selectedCompanyId" />
                    </a-tab-pane>
                    <a-tab-pane key="contract_objects" tab="Договора по объектам">
                        <ContractsObjectsTab ref="contractsObjectsTab" :selectedCompanyId="selectedCompanyId" />
                    </a-tab-pane>
                    <a-tab-pane key="contract_payments" tab="Выплаты">
                        <ContractsPaymentsTab ref="contractsPaymentsTab" :selectedCompanyId="selectedCompanyId" />
                    </a-tab-pane>
                    <a-tab-pane key="appeals" tab="Обращения по ДТП">
                        <AppealsTab ref="appealsTab" :appealsScope="appealsScope" :selectedCompanyId="selectedCompanyId"
                            @total-updated="onAppealsTotalUpdated" />
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import { Tabs, Input, DatePicker, Divider, Button, Spin, Table, Select, ConfigProvider, TreeSelect, Segmented } from 'ant-design-vue'
import ContractsTab from '@/components/personalAccount/ContractsTab.vue';
import ContractsObjectsTab from '@/components/personalAccount/ContractsObjectsTab.vue';
import ContractsPaymentsTab from '@/components/personalAccount/ContractsPaymentsTab.vue';
import AppealsTab from '@/components/personalAccount/PersonalAppeals.vue';
import ruRu from 'ant-design-vue/es/locale/ru_RU'
import { MinusCircleOutlined, SearchOutlined, CalendarOutlined, DownloadOutlined } from '@ant-design/icons-vue'
import axios from 'axios';
import { useToast } from 'vue-toastification'
import store from '@/store'
import dayjs from 'dayjs';
import moment from 'moment';

import 'moment/locale/ru';
import 'dayjs/locale/ru';
import router from "@/router";

dayjs.locale('ru');
moment.locale('ru');
const toaster = useToast();
const contractObjectColumns = [
    {
        title: 'Наименование продукта',
        dataIndex: 'product',
        key: 'product',
    },
    {
        title: 'Номер договора',
        dataIndex: 'contract_number',
        key: 'contract_number',
    },
    {
        title: 'Гос.номер ТС',
        dataIndex: 'plate_number',
        key: 'plate_number',
    },
    {
        title: 'VIN-код',
        dataIndex: 'vin',
        key: 'vin',
    },
    {
        title: 'Дата начала договора',
        dataIndex: 'start_date',
        key: 'start_date',
    },
    {
        title: 'Дата окончания договора',
        dataIndex: 'end_date',
        key: 'end_date',
    },
    {
        title: 'Страховая премия',
        dataIndex: 'insurance_premium',
        key: 'insurance_premium',
    },
    {
        title: '',
        dataIndex: 'action',
        key: 'action',
    },
];

export default {
    components: {
        AInput: Input,
        ADatePicker: DatePicker,
        ADivider: Divider,
        AButton: Button,
        ASpin: Spin,
        ATabs: Tabs,
        ASegmented: Segmented,
        ATabPane: Tabs.TabPane,
        ATable: Table,
        MinusCircleOutlined,
        SearchOutlined,
        CalendarOutlined,
        DownloadOutlined,
        ASelect: Select,
        ASelectOption: Select.Option,
        AConfigProvider: ConfigProvider,
        ATreeSelect: TreeSelect,
        ContractsTab,
        ContractsObjectsTab,
        ContractsPaymentsTab,
        AppealsTab
    },
    data() {
        return {
            ruRu,
            user: store.getters['auth/getUser'],
            selectedCompany: null,
            selectedCompanyId: null,
            notifications: [],
            activeKey: 'contract_objects',
            companies: [],
            appealsScope: 'others',
            appealsTotals: { my: 0, others: 0 },
            searchData: {
                search: null,
                type_id: 1,
                contract_type: null,
                start_date: null,
                end_date: null,
            },
            contractObjectColumns,
            contractList: [],
            productTypeList: [],
            contractTypeList: [],
            contractsObjectsList: [],
            isLoadingContractsObjectsList: false,
        }
    },
    mounted() {
        if (localStorage.getItem("auth_token")) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("auth_token")}`
        }

        if (this.user && this.user.companies && this.user.companies.length > 0) {
            this.companies = this.user.companies
            this.selectedCompany = this.user.companies[0]
            this.selectedCompanyId = this.user.companies[0].id
        }
        this.isLoadingContractList = true
        this.isLoadingContractsObjectsList = true
        this.appealsScope = this.$route.query.tab || 'others';
        // Возврат со страхового дела открывает тот же раздел, из которого ушли.
        if (this.$route.query.section) {
            this.activeKey = this.$route.query.section;
        }
        // this.getProductList()
        //  this.getQuestionnaireData(this.$route.params.id.split('-').join(''))
        //  this.getAllDicties()
    },
    methods: {
        getContracts(data) {
            axios.get(`/V1/my-contracts?company_id=${this.selectedCompanyId}`, { params: data }).then(res => {
                this.contractList = res.data.data.contracts;
                this.isLoadingContractList = false
            }).catch(error => {
                console.log(error);
            })
        },
        changeSubtab(tab) {
            this.appealsScope = tab;
            router.push({ query: { tab } });
        },
        getContractsObject(data) {
            axios.get(`/V1/my-contracts/objects?company_id=${this.selectedCompanyId}`, { params: data }).then(res => {
                this.contractsObjectsList = res.data.data.contracts_with_objects;
                this.isLoadingContractsObjectsList = false
            }).catch(error => {
                console.log(error);
            })
        },
        getProductList() {
            axios.get(`/V1/my-contracts/type-products?company_id=${this.selectedCompanyId}`).then(res => {
                this.productTypeList = res.data.data.types.map(item => {
                    return {
                        label: item.label,
                        value: item.id,
                        children: item.products.map(product => {
                            return {
                                label: product,
                                value: product,
                            }
                        })
                    }
                });
                this.contractTypeList = res.data.data.types.filter(item => item.id === 1)[0].products.map(item => {
                    return {
                        label: item,
                        value: item
                    }
                })
                if (this.contractTypeList.length === 1) {
                    this.searchData.contract_type = this.contractTypeList[0].value
                }
                this.getContracts({ ...this.searchData, start_date: this.searchData.start_date ? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY') : null })
                // this.getContractsObject({...this.searchData, start_date: this.searchData.start_date? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY'): null})
            }).catch(error => {
                console.log(error);
                if (error.status === 401) {
                    store.dispatch('auth/logoutTokenUnactive')
                    router.push('/')
                }

            })
        },
        onChangeContractNum(e) {
            this.searchData.search = e.target.value
        },
        onChangeProductType(e) {
            this.searchData.product_type = e
        },
        onChangeContractType(e) {
            this.searchData.contract_type = e
        },
        onChangeStartDate(e) {
            this.searchData.start_date = e
        },
        onChangeEndDate(e) {
            this.searchData.end_date = e
        },
        searchContract() {
            this.getContracts({ ...this.searchData, start_date: this.searchData.start_date ? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY') : null })
        },
        async downloadFile(record) {
            try {
                const response = await axios.get(record.file_path, {
                    responseType: 'blob',
                })
                const blob = new Blob([response.data])
                const downloadUrl = window.URL.createObjectURL(blob)

                const link = document.createElement('a')
                link.href = downloadUrl
                link.download = `${record.number}.pdf`
                document.body.appendChild(link)
                link.click()
                link.remove()

                window.URL.revokeObjectURL(downloadUrl)
            } catch (error) {
                console.log(error);

            }
        },
        changeCompany(companyId) {
            this.selectedCompany = this.companies.find(item => item.id === companyId)
        },
        onAppealsTotalUpdated(total) {
            this.appealsTotals[this.appealsScope] = total;
        },
    },
}
</script>

<style lang="scss" scoped>
@mixin fontStyle ($family, $style, $weight, $size, $lheight, $color) {
    font-family: $family;
    font-style: normal;
    font-weight: $weight;
    font-size: $size;
    line-height: $lheight;
    color: $color;
}

@mixin mobile {
    @media(min-width: 320px) and (max-width: 425px) {
        @content;
    }
}

@mixin tablet {
    @media(min-width: 425px) and (max-width: 767px) {
        @content;
    }
}

@mixin tablet-1024 {
    @media(min-width: 767px) and (max-width: 1024px) {
        @content;
    }
}

@mixin desktop {
    @media(min-width: 1024px) and (max-width: 1440px) {
        @content;
    }
}

@mixin desktop-max {
    @media(min-width: 1620px) and (max-width: 2560px) {
        @content;
    }
}

.col_p {
    margin-bottom: 0;
}

.personal_account {
    padding: 15px 0;

    &_company {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
				@media (max-width: 1024px) {
					flex-direction: column;
				}

        &_info {
            width: 60%;
						@media (max-width: 1024px) {
							width: 100%;
						}

            p {
                font-size: 18px;
								@media (max-width: 1024px) {
									font-size: 16px;
								}

                span {
                    font-weight: 700;
                }
            }

        }
    }

    &_title {
        @include fontStyle(Roboto, normal, 500, 24px, 31px, #373737);
        text-align: center;
				margin-bottom: 16px;
    }

    &_desc {
        @include fontStyle(Roboto, normal, 400, 22px, 31px, #909090);
        text-align: center;

        span {
            @include fontStyle(Roboto, normal, 400, 22px, 31px, #373737);
        }
    }

    &_info {
        @include fontStyle(Roboto, normal, 400, 24px, 31px, #373737);
        display: flex;
        justify-content: space-between;
        align-items: center;

        &_left {
            width: 30%;
            @include fontStyle(Roboto, normal, 400, 20px, 31px, #373737);

            &_select {
                width: 100%;
                height: 50px;
            }
        }

        &_right {
            button {
                @include fontStyle(Roboto, normal, 400, 16px, 31px, #373737);
                padding: 4px 20px;
                height: 55px;
                display: flex;
                align-items: center;

                img {
                    width: 24px;
                    margin-right: 10px;
                }
            }
        }
    }
}

.personal_account_company_select {
    width: 100%;
    max-width: 400px;
			@media (max-width: 767px) {
				max-width: 300px;
			}
}

::v-deep(.personal_account_company_select_item) {
    position: relative;
    width: 100%;

    .ant-select-selector {
        border: 1px solid #F5F5F5;
        height: auto;
        min-height: 50px;
        background: #F4F4F8;
        display: flex;
        align-items: center;
        width: 100%;
				padding-top: 4px;
				padding-bottom: 4px;

        .ant-select-selection-item {
            white-space: normal;
            word-break: break-word;
            line-height: 1.3;
        }
    }

    .ant-select-arrow {
        top: 0;
        bottom: 0;
        margin-top: 0;
        transform: none;
        height: auto;
        display: flex;
        align-items: center;
    }
}

.personal_account_company_select ::v-deep(.ant-select-dropdown) {
    .ant-select-item {
        height: auto;
    }

    .ant-select-item-option-content {
        white-space: normal;
        word-break: break-word;
        overflow: visible;
        text-overflow: unset;
        line-height: 1.3;
    }
}

::v-deep(.personal_account_info_left) {
    .ant-select-selector {
        height: 50px;

        input {
            height: 50px;
        }

        .ant-select-selection-placeholder {
            height: 50px;
            display: flex;
            align-items: center;
        }
    }
}

.product_name_col {
    display: flex;
    gap: 10px;
    align-items: center;
}

.product_name_line {
    height: 38px;
    width: 5px;
    background: #007BFF;
    border-radius: 3px;
}

.download_btn,
.open_btn {
    background-color: #fff;
    padding: 4px 8px;
    border: 2px solid #F5F5F5;
    border-radius: 4px;
    cursor: pointer;
}

.download_btn:hover,
.open_btn:hover {
    color: #007BFF !important;
    text-decoration: underline !important;
    transition: .3s;
}

.download_btn {
    span {
        color: #007BFF;
        font-size: 18px;
    }
}

.search_form {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
		row-gap: 15px;

		&_input {
        width: 100%;
    }

    &_date {
        display: flex;
        width: 38%;
        justify-content: space-between;
        height: 50px;
        align-items: center;
        gap: 15px;

        p {
            @include fontStyle(Roboto, normal, 400, 20px, 31px, #373737);
        }

        &_item {
            background: #fff;
            border-radius: 8px;
            width: 100%;

            span {
                background: #fff;
                color: #007BFF;
                border: none;
                font-size: 18px;
            }

            .ant-picker {
                background: #fff;
                border: none;
                height: 50px;
            }

            .ant-picker-focused {
                box-shadow: none;
            }
        }
    }

    &_select {
        width: 19%;
        height: 50px;
    }

    button {
        @include fontStyle(Roboto, normal, 400, 18px, 31px, #373737);
        height: 50px !important;
        border: none;
        background-color: #007BFF;
        color: #fff;
        width: 19%;
    }
}

.card-container ::v-deep(.ant-tabs) {
    .ant-tabs-nav-operations {
        display: none !important;
    }

    .ant-tabs-nav-list {
        background: #F4F4F8 !important;
        border-radius: 8px;
        width: 100%;
        justify-content: space-between;
        padding: 10px;

        @media (max-width: 1024px) {
            padding: 10px 12px;
						margin-top: 16px;
        }

        @media (max-width: 767px) {
            flex-wrap: nowrap;
            justify-content: flex-start;
            gap: 6px;
            padding: 8px;
            width: max-content;
            min-width: 0;
            flex-shrink: 0;
        }

        .ant-tabs-tab-active {
            background: white !important;

            div {
                color: #007BFF !important;
                text-decoration: none !important;
            }
        }

        .ant-tabs-tab {
            display: flex;
            justify-content: center;
            width: 30%;
            border: none;
            background: none;
						border-radius: 8px;
						padding: 6px 16px;

            @media (max-width: 767px) {
                width: auto;
                flex: 0 0 auto;
            }

            div {
                font-size: 18px;
                color: #373737;
                border-radius: 8px;
                padding: 7px 0;
                white-space: nowrap;

                @media (max-width: 1200px) {
                    font-size: 18px;
                }

                @media (max-width: 912px) {
                    font-size: 14px;
                    padding: 0;
                }
            }

            :hover {
                text-decoration: underline;
                color: #007BFF;
            }
        }

        .ant-tabs-tab:not(.ant-tabs-tab-active):hover {
            div {
                color: #007BFF !important;
                text-decoration: underline !important;
            }
        }
    }

    .ant-tabs-content-holder {
				margin-top: 0;

        .ant-tabs-tabpane {
            background: #F4F4F8 !important;
            border-radius: 8px;
        }
    }

		.ant-tabs-nav-wrap {
			&:after, &:before {
				box-shadow: none;
			}
		}
}

.subtabs {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
		margin-bottom: 16px;
}

.subtab_btn {
    @include fontStyle(Roboto, normal, 500, 16px, 24px, #373737);
    padding: 8px 20px;
    border-radius: 8px;
    border: none;
    background: #fff;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    white-space: nowrap;

    @media (max-width: 767px) {
        padding: 7px 14px;
        font-size: 14px;
    }

    &_active {
        background: #007BFF;
        color: #fff;
    }

    &:not(.subtab_btn_active):hover {
        background: #F4F4F8;
    }
}

.card-container p {
    margin: 0;
}

.card-container>.ant-tabs-card .ant-tabs-content {
    height: 120px;
    margin-top: -16px;
}

.card-container>.ant-tabs-card .ant-tabs-content>.ant-tabs-tabpane {
    padding: 16px;
    background: #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-nav::before {
    display: none;
}

.card-container>.ant-tabs-card .ant-tabs-tab,
[data-theme='compact'] .card-container>.ant-tabs-card .ant-tabs-tab {
    background: transparent;
    border-color: transparent;
}

.card-container>.ant-tabs-card .ant-tabs-tab-active,
[data-theme='compact'] .card-container>.ant-tabs-card .ant-tabs-tab-active {
    background: #fff;
    border-color: #fff;
    color: #007BFF !important;
    text-decoration: none !important;
}

</style>